import React from 'react';

import { Props } from './';

export const InputContainer: React.FC<Props> = ({ id, label, error, children }) => (
  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
    <label htmlFor={id} className="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
      {label}
    </label>

    <div className="mt-1 sm:mt-0 sm:col-span-2">
      <div className="max-w-xs rounded-md shadow-sm">{children}</div>
      {error && (
        <p className="mt-2 text-sm text-red-600" id={`${id}-error`} role="alert">
          {error.type === 'required' ? 'Este campo es obligatorio.' : error.message}
        </p>
      )}
    </div>
  </div>
);
